import image1 from '@/assets/images/news/detail/20200203/1.jpg';
import image2 from '@/assets/images/news/detail/20200203/2.jpg';
import image3 from '@/assets/images/news/detail/20200203/3.jpg';
import image4 from '@/assets/images/news/detail/20200203/4.jpg';
import image5 from '@/assets/images/news/detail/20200203/5.jpg';
import image6 from '@/assets/images/news/detail/20200203/6.jpg';

export default {
  id: '20200203', //  模块 id
  title: '作为退役军人创办的企业，“叮咚买菜”为援鄂医护人员家庭免费送菜', // 标题
  origin: '2020-02-03 15:09 来源：上观新闻', // 新闻来源
  editor: '作者：陈琼珂', // 编辑者
  content: [
    {
      type: 0,
      text:
        '“叮咚买菜”CEO梁昌霖是一位有12年军旅生涯的退役老兵，他认为在关键时刻，党员更应该发挥力量，发挥自身优势，对防控疫情进行支持',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '解放日报·上观新闻记者 陈琼珂',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '新鲜的砂糖橘、高品质冷鲜肉、崇明童子鸡、生态蔬菜……近日，浦东新区26名奋战在抗疫前线的医护人员的家中，都收到了“叮咚买菜”送上门的食材大礼包。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '“叮咚买菜”是一家送菜上门的生鲜电商企业，创始人和带头人梁昌霖是一位有12年军旅生涯的退役老兵，“叮咚买菜”也保留了浓厚的军人基因，在关键时刻和困难时刻，展现了有担当、有战斗力的军人本色。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '春节期间，“叮咚买菜”后台接单量猛增，而货源短缺与人手紧张等难题凸显，公司CEO梁昌霖立下“军令状”：“首要任务是保供应、不涨价，特别是销售量前100名的蔬菜品类，也是市民们购买最多的日常品类，一定要保障供应。”',
      isIndent: false,
    },
    {
      type: 0,
      text: '为援鄂医护人员家属送菜上门',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '2月1日，叮咚买菜的配送小哥开始向27名医护人员家庭送上食材大礼包。26名医护人员的家分布在浦东、杨浦、徐汇、嘉定、宝山、松江……最远的在苏州，为了保证菜品新鲜，叮咚买菜根据实际情况，安排距离最近的前置仓备货配送。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '收到礼包的家属及医护人员纷纷表示，来自大后方的爱心礼物让他们感觉到了浓浓的关爱与温暖。医护人员家属许先生向大家表示感谢：“谢谢组织和叮咚买菜对医护人员的关心和支持，大家的认可和鼓励，是医护人员继续前行，打赢战役的强大动力。”',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '梁昌霖介绍，“叮咚买菜”作为退役军人创业企业、浦东新区退役军人事务局红色联盟成员单位、上海市退役军人志愿者服务促进中心成员单位，牢记“若有战、召必回”诺言，在这场对抗疫情的战斗中，平台从自身优势资源出发，发挥了企业的力量、发动了人员和物资的力量，用实际行动给奋战在一线的医护人员带来了关心和尊重。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '上海有多支医疗队驰援湖北，梁昌霖表示，目前为浦东援鄂的医护人员家庭送菜是第一步，接下来，送菜行动将覆盖到上海所有援鄂医护人员家庭，“等待号令，叮咚已经准备好了。”',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text: '春节假期菜品都很充足，价格稳定',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '疫情期间正逢春节假期，如何让广大市民群众每天都能在家吃到新鲜菜，成了一大刚需。作为一名老党员和退役军人志愿者，梁昌霖敏锐地察觉到了市民的需求，他认为在关键时刻，党员更应该发挥力量，发挥自身优势，对防控疫情进行支持，“群众的呼声，就是我们的党员的哨声”。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '1月23日，“叮咚买菜”成立应急小组，全面加强商品供应。“叮咚买菜”后台数据显示，虽然春节期间，很多外地市民离沪返乡，但是很多市民不再外出买菜或聚餐，订单量仍然不降反增，大年三十的订单量同比上月增长超过300%，春节假期7天市民下单量突破400万单。其中，市民对蔬菜、水产鱼虾、猪肉的需求量最大。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '梁昌霖表示，“市民需求量大幅增加，对我们的供应带来了一些挑战。特别是春节期间，大部分食品供应商都已停止供货，物流也停止运送。但是公司正在发挥供应链优势，与各品类的核心品牌商家密切沟通，推动企业加班供应、优化库存。”针对用户需求最为旺盛的蔬菜和肉类，“叮咚买菜”通过多种渠道去加倍备货。比如上海市商委、浦东新区商务委帮助平台协调了上农批和西郊国际的新鲜猪肉和蔬菜资源。同时，平台多渠道补货，采购部门驻守在江浙周边、山东等全国各大农业基地、批发市场，加大采购。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '整个春节假期，叮咚买菜APP上市民需求最高的新鲜蔬菜、水果、活鱼活虾等货品都很充足，价格相较节前也没有太大增长，比如上海青2.5元一份，豌豆苗3.9元一份，蒜薹7.5元一份，智利车厘子29.9元一份，基本上和平时节前相差不大。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text:
        '保障近2万名一线员工的健康安全也是重中之重。1月22日，叮咚买菜发布应急响应措施：所有配送小哥及在岗员工佩戴口罩工作，并定期巡检；每天测量体温3次，并在登记表上做好体温记录，如有异常症状，立即停止工作，安排就医并上报；配送到医院等特殊区域，会按照要求将商品放在门卫处，方便用户自提，给小哥和用户多提供一层保障。',
      isIndent: false,
    },
  ],
};
